/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Typst_Studio_SubtitleInputs */

const cs_builder_typst_studio_subtitle = /** @type {(inputs: Builder_Typst_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravujte zkompilovaný Typst přímo. Preferujte Vizuální nebo Dokument, pokud nepotřebujete surovou kontrolu.`)
};

const en_builder_typst_studio_subtitle = /** @type {(inputs: Builder_Typst_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit compiled Typst directly. Prefer Visual or Document unless you need raw control.`)
};

/**
* | output |
* | --- |
* | "Edit compiled Typst directly. Prefer Visual or Document unless you need raw control." |
*
* @param {Builder_Typst_Studio_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_typst_studio_subtitle = /** @type {((inputs?: Builder_Typst_Studio_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Typst_Studio_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_typst_studio_subtitle(inputs)
	return cs_builder_typst_studio_subtitle(inputs)
});